import React from 'react';
import './CategoryTabs.css';

const CategoryTabs = ({ categories, activeCategory, onCategoryChange }) => {
  return (
    <div className="category-tabs">
      <button 
        className={`tab-button ${!activeCategory ? 'active' : ''}`}
        onClick={() => onCategoryChange(null)}
      >
        🌐 全部
      </button>
      {categories.map(category => (
        <button
          key={category.id}
          className={`tab-button ${activeCategory === category.id ? 'active' : ''}`}
          onClick={() => onCategoryChange(category.id)}
          title={category.description}
        >
          {category.icon} {category.name}
        </button>
      ))}
    </div>
  );
};

export default CategoryTabs; 